<template>
  <div 
    class="yunxiao footer" 
    :class="{ 
      'absolute-l-b': absolute,
      'multiple-btns': multipleBtns
    }">
    <van-button
      v-if="!multipleBtns"
      block
      square round
      :type="btnType"
      @click="clickHandler"
      :to="to"
      :loading="loading"
      :loading-text="loadingText"
      data-test="footer-btn"
    >
      {{ btnText }}
    </van-button>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "pageFooterBtn",
  props: {
    absolute: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loadingText: {
      type: String,
      default: "加载中...",
    },
    btnType: {
      type: String,
      default: "primary",
    },
    btnText: {
      type: String,
      default: "确定",
    },
    // 多个按钮，则其它参数无效，直接使用插槽
    multipleBtns: {
      type: Boolean,
      default: false,
    },
    to: {
      type: String | Object,
      default: () => "",
    }
  },
  methods: {
    clickHandler() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped>
.yunxiao.footer {
  width: 100%;
  padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
  // height: 50px;
  background: #fff;
  .van-button {
    height: var(--cl-xs);
  }
  &.multiple-btns{   
    display: flex;
    >button:not(:last-child){
      margin-right: calc(var(--gap) * 12);
    }
  }
}
</style>
